// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1ABlo","containerItemsCenter":"Skeleton_containerItemsCenter__1D6KL"};